import React from "react";

// Official KAME Autopůjčovna logo (transparent PNG), used everywhere.
export const Logo = ({ className = "", compact = false }) => {
  return (
    <img
      src="/images/logo.png"
      alt="KAME Autopůjčovna"
      data-testid="brand-logo"
      className={`w-auto object-contain select-none ${compact ? "h-11" : "h-16"} ${className}`}
      draggable="false"
    />
  );
};

export default Logo;
